export class Issue {
  line: number;
  text: string;
  constructor(line: number, text: string) {
    this.line = line;
    this.text = text;
  }
}
